export const toTitleCase = (str: string): string => str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

/**
 * Performs a loose match of a subcategory name against a list of available subcategories.
 * Matching is case-insensitive with trimmed whitespace.
 * Returns the canonical subcategory name if a match is found, or undefined otherwise.
 */
/**
 * Replaces UUID patterns in a message with human-readable names from a lookup map.
 * UUIDs not found in the map are left as-is.
 */
export const replaceUuidsWithNames = (msg: string, nameMap: Map<string, string>): string =>
  msg.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, (id) =>
    nameMap.get(id) ? `'${nameMap.get(id)}'` : id,
  );

export const findLooseSubcategoryMatch = (
  input: string,
  available: { subcategoryName: string }[],
): string | undefined => {
  const normalized = input.trim().toLowerCase();
  const match = available.find((sc) => sc.subcategoryName.trim().toLowerCase() === normalized);
  return match?.subcategoryName;
};
